import { callMcpTool } from './mcpClient';

/**
 * Métricas del dashboard de herramientas (#119).
 *
 * READ que igual va por el mcp-server: el cálculo (overdue, rotación,
 * ventana móvil) vive en la tool, no acá, para que el agente y la web
 * lean exactamente el mismo número.
 */
export const getToolsDashboardMetrics = async ({ window_days = 30 } = {}) =>
  callMcpTool('get_tools_dashboard_metrics', { window_days });
